import React, { Component } from "react";
import PropTypes from "prop-types";

import { Translate } from "react-redux-i18n";

import Carousel from "./Carousel";

import "../../../styles/components/utils/components/ControlRow.scss";
import arrowClockwise from "../../../styles/images/arrow-clockwise.svg";
import cogwheel from "../../../styles/images/cogwheel.svg";
import { I18n } from "react-redux-i18n";
import Infrastructure from "../classes/Infrastructure";
import EditEnergyManagement from '../../../components/chargers/modals/EditEnergyManagement'
import axios, { CancelToken } from "axios";


class ControlRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      selectedOption: this.props.currentMode && this.props.currentMode,
      showEditOptions: false,
      editOptionList: []
    };
    this.fixSelected = this.fixSelected.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.convertToKey = this.convertToKey.bind(this);
    this.roundToOneDecimalPlace = this.roundToOneDecimalPlace.bind(this);
    this.setSwitchboardConfigs = this.setSwitchboardConfigs.bind(this);
  }

  handleSelect = (event) => {
    const selectedOption = event.target.value;
    this.props.swapModeFunct(selectedOption);
    this.setState({ selectedOption });
  };

  fixSelected() {
    this.setState({ selectedOption: this.props.currentMode });
  }

  componentDidUpdate(prevProps) {
    // Check if currentMode has changed
    if (this.props.currentMode !== prevProps.currentMode) {
      // Perform actions or update state in response to the change
      this.fixSelected();
      // You can call a function or perform other actions here
    }
  }

  setSwitchboardConfigs(id) {
    axios
      .get(`/api/private/chargers/switchboard/configs/${id}`, {
        cancelToken: new axios.CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        this.setState({ editOptionList: res.data })
      })
      .catch((err) => console.error(err));
  }

  renderSearch() {
    return (
      <div className="search-container">
        <input
          type="text"
          className="search"
          value={this.props.search}
          onChange={this.props.onSearchChange}
        />
      </div>
    );
  }

  convertToKey(selectedOption) {
    let switchBoardModes = {
      "Base Mode": "chargingMode_Base_Mode",
      "Solar Mode": "chargingMode_Solar_Mode",
    };

    return switchBoardModes[selectedOption];
  }

  renderCarousel(energyManagementFlag) {
    if (
      this.props.hasOwnProperty("carousel") &&
      typeof this.props.carousel === "object"
    )
      return (
        <Carousel
          items={this.props.carousel.items}
          selected={this.props.carousel.selected}
          placeholder={this.props.carousel.placeholder}
          onSelect={this.props.carousel.onSelect}
          energyManagementFlag={energyManagementFlag}
          fixSelected={this.fixSelected}
          currentMode={this.props.currentMode}
        />
      );
  }

    roundToOneDecimalPlace(value) {
      // Convert the string to a number, round it to 1 decimal place, and convert it back to a string
      return parseFloat(value).toFixed(1);
    }

  renderControlRow() {
    if (!this.props.switchBoardModes) {
      return (
        
        <div
          id="controlRow"
          className={
            "control-row " + (this.props.buttons ? "extra-padding" : "")
          }
        >
          {this.props.hasOwnProperty("showSearch")
            ? this.props.showSearch && this.renderSearch()
            : this.renderSearch()}

          {this.props.hasOwnProperty("showCarousel")
            ? this.props.showCarousel && this.renderCarousel(false)
            : this.renderCarousel(false)}
          {this.props.buttons && (
            <div className="buttons-container">
              {this.props.buttons.map(
                (btn, i) =>
                  (btn.hasOwnProperty("show") ? btn.show : true) && (
                    <button
                      key={i}
                      type="button"
                      className={btn.className ? btn.className : "main-btn"}
                      onClick={btn.onClick ? btn.onClick : null}
                      disabled={btn.disabled ? btn.disabled : false}
                    >
                      {btn.label ? (
                        <>
                          <Translate value={btn.label} />
                          {React.isValidElement(btn.text)
                            ? btn.text
                            : btn.text && <img src={btn.text} alt="" />}
                        </>
                      ) : (
                        btn.text
                      )}
                    </button>
                  )
              )}
            </div>
          )}
        </div>
      );
    } else {
      const options = Object.values(this.props.switchBoardModes);
      

      return (
        <div
          id="controlRow"
          className={
            "control-row " + (this.props.buttons ? "extra-padding" : "")
          }
        >
          <div style={{ width: 'fit-content', minWidth: 300, maxWidth: '100%'  }}>
            {
              this.props.selectedPlace.chargingMode !== null && this.props.selectedPlace.chargingMode !== undefined && this.props.selectedPlace.chargingMode !== "No Mode" ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div>
              <Translate value="chargingMode_energyManagement" /> : 
              </div>
              <div style={{ flexShrink: 0 }}><Translate value={this.convertToKey(this.props.selectedPlace.chargingMode)} /></div>
            </div>) : null }
            
            {
              this.props.selectedPlace.sharingMode !== null && this.props.selectedPlace.sharingMode !== undefined && this.props.selectedPlace.sharingMode !== "" ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div>
              <Translate value="sharingMode_energyManagement" /> : 
              </div>
              <div style={{ flexShrink: 0 }}>{this.props.selectedPlace.sharingMode}</div>
            </div>) : null
            }
            {
              this.props.selectedPlace.minSolarCurrent !== null && this.props.selectedPlace.minSolarCurrent !== undefined ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <div>
                    <Translate value="solarMinimum_energyManagement" /> :
                  </div>
                  <div style={{ flexShrink: 0 }}>{this.roundToOneDecimalPlace(this.props.selectedPlace.minSolarCurrent)}(A)</div>
                </div>
              ) : null
            }
            {this.props.selectedPlace.currentLimit !== null && this.props.selectedPlace.currentLimit !== undefined ?
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div>
              <Translate value="currentLimit_energyManagement" /> : 
              </div>
              <div style={{ flexShrink: 0 }}>{this.roundToOneDecimalPlace(this.props.selectedPlace.currentLimit)}(A)</div>
            </div> : null
            }
          </div>

          {this.props.hasOwnProperty("showSearch")
            ? this.props.showSearch && this.renderSearch()
            : this.renderSearch()}
          {this.props.hasOwnProperty("showCarousel")
            ? this.props.showCarousel && this.renderCarousel(true)
            : this.renderCarousel(true)}

          {this.props.showRefresh && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              {this.props.showRefresh && (
                <div style={{ paddingRight: "10px" }}>
                  <img
                    src={arrowClockwise}
                    onClick={() => {
                      this.props.refreshContent();
                    }}
                    alt="refresh"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>
              )}
                <div style={{ paddingRight: "10px" }}>
                  <img
                    src={cogwheel}
                    onClick={() => {
                      this.setSwitchboardConfigs(this.props.selectedPlace.id);
                      this.setState({ showEditOptions: true })
                    }}
                    alt="refresh"
                    style={{ width: "35px", height: "35px" }}
                  />
                </div>

                <EditEnergyManagement refreshData={this.props.refreshData} show={this.state.showEditOptions} onHide={() => {this.setState({ showEditOptions: false })}} editOptionList={this.state.editOptionList}></EditEnergyManagement>
              
            </div>
          )}
          {this.props.buttons && (
            <div className="buttons-container">
              {this.props.buttons.map(
                (btn, i) =>
                  (btn.hasOwnProperty("show") ? btn.show : true) && (
                    <button
                      key={i}
                      type="button"
                      className={btn.className ? btn.className : "main-btn"}
                      onClick={btn.onClick ? btn.onClick : null}
                      disabled={btn.disabled ? btn.disabled : false}
                    >
                      {btn.label ? (
                        <>
                          <Translate value={btn.label} />
                          {React.isValidElement(btn.text)
                            ? btn.text
                            : btn.text && <img src={btn.text} alt="" />}
                        </>
                      ) : (
                        btn.text
                      )}
                    </button>
                  )
              )}
            </div>
          )}
        </div>
      );
    }
  }

  render() {
    return this.props.hasOwnProperty("show")
      ? this.props.show && this.renderControlRow()
      : this.renderControlRow();
  }
}

ControlRow.propTypes = {
  show: PropTypes.bool,
  showSearch: PropTypes.bool,
  search: PropTypes.string,
  onSearchChange: PropTypes.func,
  buttons: PropTypes.array,
  showRefresh: PropTypes.bool,
  refreshContent: PropTypes.func,
  showSwapMode: PropTypes.bool,
  swapModeFunct: PropTypes.func,
  switchBoardModes: PropTypes.object,
  currentMode: PropTypes.string,
  // eslint-disable-next-line react/no-typos
  selectedPlace: PropTypes.instanceOf(Infrastructure),
  // eslint-disable-next-line react/no-typos
  places: PropTypes.arrayOf(PropTypes.instanceOf(Infrastructure)),
  getSwitchboardConfigs: PropTypes.func,
  fetchPlaces: PropTypes.func
};

export default ControlRow;